export default "__VITE_ASSET__DfDx6GpS__"